import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Calendar from 'react-calendar';
import 'assets/styles/common.scss';
import 'Pages/Admin/DoctorList/DoctorDetail/ScheduleTab/Schedule.scss';
import 'react-calendar/dist/Calendar.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';

const localizer = momentLocalizer(moment);

const ScheduleTab = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEventId, setSelectedEventId] = useState(null);

  const highlightWeekends = ({ date }) => {
    const today = new Date().toDateString();
    const day = date.getDay();
    const isToday = date.toDateString() === today;
    const isSelected = date.toDateString() === selectedDate?.toDateString();
    const isPast = disablePastDates({ date });

    if (isSelected) return 'selected';
    if (isToday) return 'today';
    if (isPast && (day === 0 || day === 6)) return 'disabled-weekend';
    if (day === 0) return 'sunday-highlight';
    if (day === 6) return 'saturday-highlight';
    return null;
  };

  const handleNavigationClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const disablePastDates = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date < today;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const [events, setEvents] = useState([
    {
      start: new Date('2025-01-20T09:00:00'),
      end: new Date('2025-01-20T10:00:00'),
      title: 'Appointment with Clyde Johnson',
    },
    {
      start: new Date('2025-01-20T09:30:00'),
      end: new Date('2025-01-20T10:30:00'),
      title: 'Appointment with Clyde Johnson 1',
    },
    {
      start: new Date('2025-01-20T10:00:00'),
      end: new Date('2025-01-20T11:00:00'),
      title: 'Team Meeting',
    },
    {
      start: new Date('2025-01-20T15:00:00'),
      end: new Date('2025-01-20T16:00:00'),
      title: 'Project Discussion',
    },
    {
      start: new Date('2025-01-20T09:00:00'),
      end: new Date('2025-01-20T10:00:00'),
      title: 'Client Call',
    },
  ]);

  const formatDate = (date) => moment(date).format('YYYY-MM-DD');
  const filteredEvents = events.filter(
    (event) => formatDate(event.start) === formatDate(selectedDate)
  );

  const handleSelectEvent = (event) => {
    setSelectedEventId(event.id);
  };

  const dayPropGetter = (date) => {
    if (moment(date).isSame(moment(), 'day')) {
      return {
        style: {
          backgroundColor: 'transparent',
        },
      };
    }
    return {};
  };

  return (
    <div className="pt-24">
      <Row className="g-4 m-0">
        <Col md={6} lg={4} xl={3} className="p-0 m-0">
          <div className="calendar-container">
            <Calendar
              next2Label={null}
              prev2Label={null}
              tileClassName={highlightWeekends}
              formatShortWeekday={(locale, date) => date.toString().charAt(0)}
              onChange={handleDateChange}
              value={selectedDate}
              tileDisabled={disablePastDates}
              navigationLabel={({ date, label }) => (
                <button
                  onClick={handleNavigationClick}
                  style={{
                    minWidth: '44px',
                    background: 'none',
                    cursor: 'not-allowed',
                  }}
                  disabled
                >
                  {label}
                </button>
              )}
            />
          </div>
        </Col>
        <Col xl={8} className="size-padding-large m-0">
          <div className="w-100">
            <div className="fs-24 fc-292D32 family_outfit_medium_500">
              {moment(selectedDate).format('MMM DD, YYYY')}
            </div>
            <div className="big-calendar-container mt-3">
              <BigCalendar
                localizer={localizer}
                events={filteredEvents}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 'auto' }}
                views={['day']}
                defaultView="day"
                date={selectedDate}
                toolbar={false}
                dayLayoutAlgorithm="no-overlap"
                dayPropGetter={dayPropGetter}
                eventPropGetter={(event) => {
                  if (selectedEventId && event.id === selectedEventId) {
                    return {
                      style: {
                        border: '1px solid #FEF9F6',
                        backgroundColor: '#FEF9F6',
                        outline: 'none',
                      },
                    };
                  }
                  return {
                    style: {
                      border: '1px solid #FEF9F6',
                      outline: 'none',
                    },
                  };
                }}
                onSelectEvent={handleSelectEvent}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ScheduleTab;
